import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'communities',
  children: {
    id: {
      path: ':id',
    },
  },
} as const satisfies Location
